import { HStack, Box, VStack, Text } from '@chakra-ui/react';

const AttachmentRow = ({ icon, label, subLabel, onClick, colors }) => (
    <HStack
        w={'full'}
        gap={3}
        px={4}
        py={3}
        cursor="pointer"
        onClick={onClick}
        borderRadius="md"
        transition="background 0.15s"
        _hover={{ bg: colors.attachmentHover }}
    >
        <Box
            w={10}
            h={10}
            borderRadius="full"
            bg={colors.attachmentHover}
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexShrink={0}
        >
            {icon}
        </Box>
        <VStack gap={0} alignItems="flex-start">
            <Text fontSize="sm" fontWeight="500" color={colors.textPrimary}>{label}</Text>
            <Text fontSize="xs" color={colors.textSecondary}>{subLabel}</Text>
        </VStack>
    </HStack>
);

export default AttachmentRow;
